<script>
  export default {
    name: 'screen-group-new-modal',

    data () {
      return {
        group: {}
      }
    },

    methods: {
      handleOk (e) {
        e.preventDefault()

        this.$store.dispatch('screenGroups/addGroup', this.group).then(() => {
          this.$refs.modal.hide()
          this.group = {}
        }).catch((err) => {
          console.log('Unable to add screen group', err)
        })
      }
    },

    created () {
      this.$emit('update:title', 'New Screen Group')
      this.$emit('update:ok-title', 'Save & Continue')
    }
  }
</script>

<template>
  <b-card-body>
  </b-card-body>
</template>
